export default class SepaCreditTransferExport {
    static fromData(data) {
        if (!data) {
            return;
        }

        const sepaDirectDebitExport = new SepaCreditTransferExport();
        sepaDirectDebitExport.id = data.id;
        sepaDirectDebitExport.createdAt = data.createdAt;
        sepaDirectDebitExport.numberOfInvoices = data.numberOfInvoices;

        return sepaDirectDebitExport;
    }
}
